export function computeProgress(completed: number, total: number) {
  return Math.min(Math.trunc((completed / Math.max(1, total)) * 100), 100);
}
